var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#ffd39f;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:url(#linear-gradient-15);}.cls-17{fill:url(#linear-gradient-16);}.cls-18{fill:url(#linear-gradient-17);}.cls-19{fill:url(#linear-gradient-18);}.cls-20{fill:url(#linear-gradient-19);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 32,
    y1: 50,
    x2: 32,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7aa8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3d2e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32,
    y1: 46,
    x2: 32,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbcc88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe5c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 38,
    y1: 63,
    x2: 38,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9a254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4bb79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 49,
    x2: 49,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 26,
    x2: 26,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 15,
    x2: 15,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 26,
    y1: 5,
    x2: 26,
    y2: 1,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 15,
    y1: 5,
    x2: 15,
    y2: 1,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 5,
    y2: 1,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 49,
    y1: 5,
    x2: 49,
    y2: 1,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 3,
    y1: 40,
    x2: 3,
    y2: 36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 3,
    y1: 51,
    x2: 3,
    y2: 47,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 3,
    y1: 28,
    x2: 3,
    y2: 24,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 3,
    y1: 17,
    x2: 3,
    y2: 13,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 61,
    y1: 28,
    x2: 61,
    y2: 24,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 61,
    y1: 17,
    x2: 61,
    y2: 13,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 61,
    y1: 40,
    x2: 61,
    y2: 36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 61,
    y1: 51,
    x2: 61,
    y2: 47,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 32,
    y1: 42,
    x2: 32,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#474f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878c9f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Technology") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Technology"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14,
    y: 14,
    width: 36,
    height: 36,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18,
    y: 18,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18,
    y: 18,
    width: 28,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 38,
    cy: 61,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 49,
    cy: 61,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 26,
    cy: 61,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 15,
    cy: 61,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 26,
    cy: 3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 15,
    cy: 3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 38,
    cy: 3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 49,
    cy: 3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 3,
    cy: 38,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 3,
    cy: 49,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 3,
    cy: 26,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 3,
    cy: 15,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 61,
    cy: 26,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 61,
    cy: 15,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 61,
    cy: 38,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 61,
    cy: 49,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M39.7,29.86l2-1.13-2-3.46L37.71,26.4A8.06,8.06,0,0,0,34,24.26V22H30v2.26a8.06,8.06,0,0,0-3.71,2.14l-1.95-1.13-2,3.46,2,1.13a7.78,7.78,0,0,0,0,4.28l-2,1.13,2,3.46,1.95-1.13A8.06,8.06,0,0,0,30,39.74V42h4V39.74a8.06,8.06,0,0,0,3.71-2.14l1.95,1.13,2-3.46-2-1.13A7.78,7.78,0,0,0,39.7,29.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 32,
    cy: 32,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,17H18a1,1,0,0,0-1,1V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V18A1,1,0,0,0,46,17ZM45,45H19V19H45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,36a4,4,0,1,0-4-4A4,4,0,0,0,32,36Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,32,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,30c.44,0,.49-.12,2.34-1.5A3,3,0,1,0,58,26c0,1.28.74.44-1.33,2H51V24c5.27,0,5.44.17,5.85-.47l3.5-5.6a3,3,0,1,0-1.69-1.07L55.45,22H51V18a5,5,0,0,0-5-5H42V9h7a1,1,0,0,0,1-1V5.82a3,3,0,1,0-2,0V7H41a1,1,0,0,0-1,1v5H36V7.33l1.11-1.48A3,3,0,1,0,35.5,4.66C33.6,7.2,34,5.43,34,13H30V7c0-.44-.12-.49-1.5-2.34A3,3,0,1,0,26,6c1.28,0,.44-.74,2,1.33V13H24c0-5.27.17-5.44-.47-5.85l-5.6-3.5a3,3,0,1,0-1.07,1.69L22,8.55V13H18a5,5,0,0,0-5,5v4H9V15a1,1,0,0,0-1-1H5.82a3,3,0,1,0,0,2H7v7a1,1,0,0,0,1,1h5v4H7.33L5.85,26.89A3,3,0,1,0,4.66,28.5C7.2,30.4,5.43,30,13,30v4H7c-.44,0-.49.12-2.34,1.5A3,3,0,1,0,6,38c0-1.28-.74-.44,1.33-2H13v4c-5.27,0-5.44-.17-5.85.47l-3.5,5.6a3,3,0,1,0,1.69,1.07L8.55,42H13v4a5,5,0,0,0,5,5h4v4H15a1,1,0,0,0-1,1v2.18a3,3,0,1,0,2,0V57h7a1,1,0,0,0,1-1V51h4v5.67l-1.11,1.48a3,3,0,1,0,1.61,1.19C30.4,56.8,30,58.57,30,51h4v6c0,.44.12.49,1.5,2.34A3,3,0,1,0,38,58c-1.28,0-.44.74-2-1.33V51h4c0,5.27-.17,5.44.47,5.85l5.6,3.5a3,3,0,1,0,1.07-1.69L42,55.45V51h4a5,5,0,0,0,5-5V42h4v7a1,1,0,0,0,1,1h2.18a3,3,0,1,0,0-2H57V41a1,1,0,0,0-1-1H51V36h5.67l1.48,1.11a3,3,0,1,0,1.19-1.61C56.8,33.6,58.57,34,51,34V30Zm4-5a1,1,0,0,1,0,2A1,1,0,0,1,61,25Zm0-11a1,1,0,0,1,0,2A1,1,0,0,1,61,14ZM49,2a1,1,0,0,1,0,2A1,1,0,0,1,49,2ZM38,2a1,1,0,0,1,0,2A1,1,0,0,1,38,2ZM25,3a1,1,0,0,1,2,0A1,1,0,0,1,25,3ZM15,4a1,1,0,0,1,0-2A1,1,0,0,1,15,4ZM3,16a1,1,0,0,1,0-2A1,1,0,0,1,3,16ZM2,26a1,1,0,0,1,2,0A1,1,0,0,1,2,26ZM3,39a1,1,0,0,1,0-2A1,1,0,0,1,3,39ZM3,50a1,1,0,0,1,0-2A1,1,0,0,1,3,50ZM15,62a1,1,0,0,1,0-2A1,1,0,0,1,15,62Zm11,0a1,1,0,0,1,0-2A1,1,0,0,1,26,62Zm13-1a1,1,0,0,1-2,0A1,1,0,0,1,39,61Zm10-1a1,1,0,0,1,0,2A1,1,0,0,1,49,60ZM61,48a1,1,0,0,1,0,2A1,1,0,0,1,61,48Zm1-10a1,1,0,0,1-2,0A1,1,0,0,1,62,38ZM49,46a3,3,0,0,1-3,3H18a3,3,0,0,1-3-3V18a3,3,0,0,1,3-3H46a3,3,0,0,1,3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.47,39.23a1,1,0,0,0,1.37.37l1.31-.76A9.21,9.21,0,0,0,29,40.48V42a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V40.48a9,9,0,0,0,2.84-1.64l1.32.76a1,1,0,0,0,1.37-.37l2-3.46a1,1,0,0,0-.37-1.37l-1.32-.76a8.61,8.61,0,0,0,0-3.28l1.32-.76a1,1,0,0,0,.37-1.37l-2-3.46a1,1,0,0,0-1.37-.37l-1.32.76A9,9,0,0,0,35,23.52V22a1,1,0,0,0-1-1H30a1,1,0,0,0-1,1v1.52a9.21,9.21,0,0,0-2.85,1.64l-1.31-.76a1,1,0,0,0-1.37.37c-2.71,4.69-2.86,4.12-.31,5.59a8.61,8.61,0,0,0,0,3.28C20.59,35.12,20.78,34.56,23.47,39.23Zm1.79-5.36a6.79,6.79,0,0,1,0-3.74c.24-.86-.46-1.13-1.55-1.76l1-1.74,1.08.63c1.24.71,1.36-1.23,4.46-2,.86-.22.75-.95.75-2.23h2v1.26c0,1.43,1.76.56,4,2.84.63.64,1.23.15,2.3-.47l1,1.74L39.2,29c-1,.55-.2,1.3-.2,3s-.75,2.45.2,3l1.09.63-1,1.74c-1-.6-1.65-1.13-2.3-.47-2.23,2.28-4,1.41-4,2.84V41H31V39.74a1,1,0,0,0-.75-1c-3.11-.8-3.22-2.75-4.46-2l-1.08.63-1-1.74C24.75,35,25.51,34.76,25.26,33.87Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/Technology.4796c0e15b489f620cfd19de3932484b.svg";
export { ForwardRef as ReactComponent };